// export const API_BASE_URL = "http://localhost:8000/v1/api";

export const API_BASE_URL = "/v1/api";


